$(document).ready(() => {
    $('.ad-bubble > .close').click(() => {
        Cookies.set('ad-bubble-show', 1, {expires: 365 * 10, path: '/'});
        $('.ad-bubble').hide();
    });
    if (!Cookies.get('ad-bubble-show')) {
        $('.ad-bubble').show();
    }
});

Bingo.LandingPage = {};

Bingo.LandingPage.init = function () {
    $(window).resize(() => {
        Bingo.ImageController.init();
    });
};

Bingo.LandingPage.Carousel = {};

Bingo.LandingPage.Carousel.init = function (id) {
    Bingo.ImageController.init();

    new Swiper(`${id} .swiper-container`, {
        preloadImages: false,
        slidesPerView: 'auto',
        lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: true,
            elementClass: 'swiper-in-swiper-first-slide-lazy',
        },
        watchSlidesVisibility: true,
        navigation: {
            nextEl: `${id} .swiper-to-right`,
            prevEl: `${id} .swiper-to-left`,
        },
        spaceBetween: 15,
        speed: 850,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
        on: {
            init() {
                if (this.visibleSlides) {
                    this.lazy.loadInSlide(this.visibleSlides.length);
                    $('.js-O-slider__swiperContainer').removeClass('-waitingToInit');
                }
            },
            slideChange() {
                this.lazy.loadInSlide(this.activeIndex + this.visibleSlides.length);
            },
        },
    });
};

Bingo.LandingPage.Customers = {};

Bingo.LandingPage.Customers.init = function () {
    Bingo.ResponsiveTabs.init('#js-tabsSwiper-apartments');
    Bingo.ResponsiveTabs.init('#js-tabsSwiper-houses');
    Bingo.ResponsiveTabs.init('#js-tabsSwiper-offices');

    $('.js-landingPage__blogSection').viewportChecker(() => {
        Bingo.LandingPage.Carousel.init('#newsfeed');
    });

    $('.js-landingPage__servicesSection').viewportChecker(() => {
        Bingo.AdManager.init('js-ad-manager-zone-lp-1');
        Bingo.AdManager.init('js-ad-manager-zone-lp-2');
        Bingo.AdManager.init('js-ad-manager-zone-lp-3');
        Bingo.AdManager.init('js-ad-manager-zone-lp-4');
        Bingo.AdManager.init('js-ad-manager-zone-lp-5');
        Bingo.AdManager.init('js-ad-manager-zone-lp-6');
        Bingo.AdManager.init('js-ad-manager-zone-lp-7');
        Bingo.AdManager.init('js-ad-manager-zone-lp-8');
        Bingo.AdManager.init('js-ad-manager-zone-lp-9');
        Bingo.AdManager.init('js-ad-manager-zone-lp-10');
    });
};

Bingo.LandingPage.PropertyOwners = {};

Bingo.LandingPage.PropertyOwners.init = function () {
    function setSameHeightForWeHelpBlocks() {
        const el = $('#we-help');
        el.find('h3').css('height', '');
        el.find('p').css('height', '');
        if (window.matchMedia('(min-width: 768px)').matches) {
            itemsInLine = 2;
            if (window.matchMedia('(min-width: 992px)').matches) {
                itemsInLine = 3;
            }
            el.sameHeight({iterator: itemsInLine, selector: '.we-help-block h3'});
            el.sameHeight({iterator: itemsInLine, selector: '.we-help-block p'});
        }
    }

    $(document).ready(() => {
        setSameHeightForWeHelpBlocks();
    });
    $(window).resize(() => {
        setSameHeightForWeHelpBlocks();
    });
};

Bingo.LandingPage.LoadSwipersOnTabClick = {};
Bingo.LandingPage.LoadSwipersOnTabClick.init = function (loadSwiperDataUrl) {
    $('.js_tabsSwiper__tab').on('click', function () {
        const swiperTabId = $(this).data('swiper-tab-id');

        Bingo.LandingPage.SwiperTabLoader.show(swiperTabId);

        $.nette.ajax({
            url: loadSwiperDataUrl,
            data: {
                tabId: swiperTabId,
            },
            disableSpinner: true,
            off: ['unique'], // this ensures that unique nette extension is disabled, therefore multiple nette ajax requests can be ran at the same time
            success: () => {
                Bingo.LandingPage.SwiperTabLoader.hide(swiperTabId);
            },
        });
    });
};

Bingo.LandingPage.LoadSwipersWhenInViewport = {};
Bingo.LandingPage.LoadSwipersWhenInViewport.init = function (loadSwiperDataUrl) {
    // load swipers already in viewport on first page load
    Bingo.LandingPage.LoadSwipersWhenInViewport.handler(loadSwiperDataUrl);
    $(window).scroll(() => {
        Bingo.LandingPage.LoadSwipersWhenInViewport.handler(loadSwiperDataUrl);
    });
};
Bingo.LandingPage.LoadSwipersWhenInViewport.handler = function (loadSwiperDataUrl) {
    $('.js_tabsSwiper__loadWhenInViewport').each(function () {
        if ($(this).isOnScreen() && $(this).data('swiper-tab-loaded') === false) {
            $(this).data('swiper-tab-loaded', true);

            const swiperTabId = $(this).data('swiper-tab-id');

            Bingo.LandingPage.SwiperTabLoader.show(swiperTabId);

            $.nette.ajax({
                url: loadSwiperDataUrl,
                data: {
                    tabId: $(this).data('swiper-tab-id'),
                },
                off: ['unique'], // this ensures that unique nette extension is disabled, therefore multiple nette ajax requests can be ran at the same time
                disableSpinner: true,
                success: () => {
                    Bingo.LandingPage.SwiperTabLoader.hide(swiperTabId);
                },
            });
        }
    });
};

Bingo.LandingPage.SwiperTabLoader = {};
Bingo.LandingPage.SwiperTabLoader.show = function (swiperTabId) {
    const renderedTabArea = $(`#lp-properties-${swiperTabId}`);

    // clear rendered area inside corresponding snippet
    renderedTabArea.find(`#snippet--${swiperTabId}`).html('');

    // append loader to rendered area for smooth transition
    if (renderedTabArea.find('.js_tabsSwiper__tabLoader').length === 0) {
        const loader = '<div class="M-swiperTab__cover js_tabsSwiper__tabLoader px-0"><div class="A-spinner -blue"><div class="A-spinner__part"></div></div></div>';
        renderedTabArea.append(loader);
    }
};
Bingo.LandingPage.SwiperTabLoader.hide = function (swiperTabId) {
    // remove loader from rendered area
    $(`#lp-properties-${swiperTabId} .js_tabsSwiper__tabLoader`).remove();
};
